import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { libraryType, Library } from '../types/library'
import {
  libraryQueryArgsType,
  LibraryQueryArgs
} from '../types/library-query-args'
import { normalizeLibrary } from './helpers/library'
import { ContrastQueryParameters } from '../endpoint-helpers'

export const library: GraphQLFieldConfig<any, Context, LibraryQueryArgs> = {
  description: 'Get a Library by hash, language, and Organization ID',
  type: new GraphQLNonNull(libraryType),
  args: libraryQueryArgsType,
  async resolve(_source, args, { connector }): Promise<Library> {
    const { organizationID, hash, language } = args

    const params = new ContrastQueryParameters()
    params.append('expand', 'vulns,skip_links,apps')

    const { library } = await connector.get(
      `/${organizationID}/libraries/${language}/${hash}?${params}`
    )

    return normalizeLibrary(library)
  }
}
